import { render, staticRenderFns } from "./formatos.vue?vue&type=template&id=f43930e2&scoped=true&"
import script from "./formatos.vue?vue&type=script&lang=js&"
export * from "./formatos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f43930e2",
  null
  
)

export default component.exports